import {Component, OnInit} from '@angular/core';
import {UsuariosService} from '../usuarios/usuario.service';
import {Sucursal} from '../sucursal/sucursal';
import {SucursalService} from '../sucursal/sucursal.service';
import {Empresa} from '../empresa/empresa';
import {Nodo} from '../nodo/nodo';
import {NodoService} from '../nodo/nodo.service';
import {MedicionService} from '../medicion/medicion.service';
import {Ubicacion} from '../ubicacion/ubicacion';
import {RolService} from '../rol/rol.service';
import {EmpresaService} from '../empresa/empresa.service';
import {PermisoService} from '../permiso/permiso.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../login/login.service';
import {RegAlarma} from './regAlarma';
import {RegAlarmaService} from './regAlarma.service';
import 'rxjs/Rx';

declare var $: any;
import myGlobals = require('../config');

var moment = require('moment');

@Component({
    selector: 'alarmasNotificacion',
    template: require('../../app/regAlarma/regalarmas.component.html'),
    styles: [require('../../app/regAlarma/regalarmas.component.css')]
})
export class RegAlarmasComponent implements OnInit {
    sucursales: Sucursal[];
    permisos: any;
    empresas: Empresa[];
    ubicaciones: Ubicacion[];
    sucursalSeleccionada: Sucursal;
    offsetTimeZone: string;
    nodos: Nodo[];
    regAlarma: RegAlarma[];
    regAlarmaNodos: RegAlarma[];
    socket: any;
    ultimoColor: number;
    colors: Array<any>;
    abierto: any;
    asignacionColor: any;
    //abierto:Boolean;
    noData: any;
    fechaDesde: any;
    fechaHasta: any;
    mostrarEliminados: boolean;
    idSensores: Array<any>;
    idNodos: Array<any>;
    usuarioConectado: any;

    constructor(private usuarioService: UsuariosService,
                private sucursalService: SucursalService,
                private empresaService: EmpresaService,
                private route: ActivatedRoute,
                private loginService: LoginService,
                private permisoService: PermisoService,
                private rolService: RolService,
                private regAlarmaService: RegAlarmaService,
                private nodoService: NodoService,
                private medicionService: MedicionService,
                private router: Router) {
        this.abierto = true;
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        this.usuarioConectado = this.loginService.getDecodeToken();

        //Perdir permisos
        this.abierto = true;
        this.regAlarma = [];
        this.regAlarmaNodos = [];
        this.idSensores = [];
        this.idNodos = [];
        this.sucursalSeleccionada = null;
        this.mostrarEliminados = false;
        this.fechaDesde = new Date().toISOString().substring(0, 10);
        this.fechaHasta = new Date().toISOString().substring(0, 10);
        this.offsetTimeZone = "-03:00";

        //Obtener empresas de ese usuario
        this.empresaService.getEmpresas()
            .subscribe(
                data => {
                    this.empresas = data;
                    if (data.length > 0)
                        this.cambiarSucursales(data[0]._id);
                });

        this.permisos = new Map();
        this.permisoService.getPermiso("alarma").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });

        //Inicializar tabla
        $("#alertSeleccion").hide();

        //Ocultar la barra cuando hace click afuera
        if ($(window).width() < 769)
            $(document).bind("mouseup touchend", function (e) {
                var container = $("#barraSelectora");
                if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0
                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
                    && e.target.id != "flechaBarraSelectora") // ... nor a descendant of the container
                {
                    $('#barraSelectora').css("display", "none");
                }
            });

        setTimeout(() => this.loadTable(), 1000)
        setTimeout(() => $("#grid-data").bootgrid("reload"), 1000)
        $("#grid-data").bootgrid("reload");
    }

    ngOnDestroy() {
    }

    cambiarSucursales(id) {
        this.idSensores = [];
        this.idNodos = [];
        $("#grid-data").bootgrid("destroy");
        this.sucursalService.getSucursalByEmpresa(id).subscribe((data) => {
            this.sucursales = data;
            if (data.length > 0) {
                //Calcular fechaDesde para mostrar histórico
                var fechaDesde = new Date();
                fechaDesde.setDate(fechaDesde.getDate() - data[0].historico_dias);
                this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
                this.cambiarSensores(data[0]._id);
            } else {
                this.sucursales = [];
                this.ubicaciones = [];
            }
        });
    }

    loadTable() {
        //Alarmas Por Sensor
        $("#grid-data").bootgrid({
            ajax: true,
            selection: true,
            multiSelect: false,
            rowSelect: false,
            templates: {
                search: ""
            },
            formatters: {
                "nodo": function (column, row) {
                    return (row.nodo_id != undefined ? row.nodo_id.nombre : "") + (row.sensor_id != undefined ? ' - ' + row.sensor_id.etiqueta : "");
                },
                "color": function (column, row) {
                    let info = '';
                    let displayName = row.tipoEspecial == null ? "Alarma por rango" : (row.tipoEspecial == "SINACTIVIDAD" ? "Sin Actividad" : row.tipoEspecial == "SENSORNULL" ? "Sensor sin información" : (row.tipoEspecial == "CALIBRACION" ? "Próxima calibración" : "Bateria Baja"));
                    info = info + '<b>' + displayName + '</b></br></br>'
                    if (row.color == 'Amarillo')
                        info += "<span class='label label-warning'>Amarillo</span></br>";
                    else
                        info += "<span class='label label-danger'>Rojo</span></br>";
                    return info;
                },
                "fechaActivado": function (column, row) {
                    var date_str = row.fechaActivado;
                    if (moment(date_str).isValid())
                        return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
                    else
                        return "";
                }.bind(this),
                "fechaDesactivado": function (column, row) {
                    if (row.fechaDesactivado != null) {
                        var date_str = row.fechaDesactivado;
                        if (moment(date_str).isValid())
                            return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
                        else
                            return "";
                    } else {
                        return "Aún activa";
                    }
                }.bind(this),
                "usuarios": function (column, row) {
                    let key = row.tipoEspecial == null ? "rango" : (row.tipoEspecial == "SINACTIVIDAD" ? "sinactividad" : row.tipoEspecial == "SENSORNULL" ? "sensornull" : (row.tipoEspecial == "CALIBRACION" ? "calibracion" : "bateria"));
                    if (row.usuarios.length > 0) {
                        return row.usuarios.map((usuario) => '<b style="font-family: Raleway Bold !important">' + (usuario.nombre + ' ' + usuario.apellido) + '</b><br/>' + Object.entries(usuario[key]).map(([channel, value]) => value === true ? channel.toUpperCase() : ' - ').join('')).join('<br/>');
                    } else {
                        return "Sin avisos";
                    }
                }.bind(this),
                "notificaciones": function (column, row) {
                    if (row.notificaciones.length > 0) {
                        let usuarios = {};
                        row.notificaciones.forEach((notificacion) => {
                            let usuario = usuarios[notificacion.usuario_id._id];
                            if (!usuario) {
                                usuarios[notificacion.usuario_id._id] = {
                                    usuario: notificacion.usuario_id.nombre + ' ' + notificacion.usuario_id.apellido,
                                    avisos: []
                                };
                            }
                            usuarios[notificacion.usuario_id._id].avisos.push({
                                tipo: notificacion.tipo,
                                fecha: moment(notificacion.fechaEnvio).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm")
                            });
                        })
                        return Object.values(usuarios).map((usuario) => '<b style="font-family: Raleway Bold !important">' + usuario.usuario + '</b><br/>' + usuario.avisos.map((aviso) => aviso.tipo + ' ' + aviso.fecha).join('<br/>')).join('<br/>');
                    } else {
                        return "Sin avisos";
                    }
                }.bind(this),
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            },

            requestHandler: function (request) {
                request.sensores = JSON.stringify({sensores_id: this.idSensores});
                request.idSucursal = this.sucursalSeleccionada._id;
                if (this.fechaDesde != null) {
                    request.fechaDesde = moment(this.fechaDesde).utcOffset(this.offsetTimeZone).startOf("day").format();
                }
                if (this.fechaHasta != null) {
                    request.fechaHasta = moment(this.fechaHasta).utcOffset(this.offsetTimeZone).endOf("day").format();
                }
                return request;
            }.bind(this),
            url: myGlobals.default.BASE_URL + "/regAlarma/regAlarmasNotificacionTable/"
        }).bind(this);
        $("#grid-data").bootgrid("reload");

    }

    buscarAlarmas(e, sensor) {

        if (e.target.checked) {
            var index = this.idSensores.indexOf(sensor._id);
            if (index == -1) {
                this.idSensores.push(sensor._id);
            }
            this.idNodos.push(sensor.nodo_id);
            this.noData = false;
            this.loadTable();

            for (let ubicacion of this.ubicaciones) {
                for (let sensor of ubicacion.sensores) {
                    $("#" + sensor._id).attr('disabled', false);
                }
            }
        }
        //Si deselecciona un casillero
        else {
            var index = this.idSensores.indexOf(sensor._id);
            if (index != -1) {
                this.idSensores.splice(index, 1);
            }
            var index = this.idNodos.indexOf(sensor.nodo_id);
            if (index != -1) {
                this.idNodos.splice(index, 1);
            }
            $("#grid-data").bootgrid("reload");
        }
    }

    cambiarFecha() {
        this.loadTable();
    }

    cambiarSensores(id) {
        this.idSensores = [];
        this.idNodos = [];
        $("#grid-data").bootgrid("destroy");
        //Calcular fechaDesde
        for (let sucursal of this.sucursales) {
            if (sucursal._id == id) {
                this.sucursalSeleccionada = sucursal;
                if (sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
                else
                    this.offsetTimeZone = "-03:00";
                break;
            }
        }
        var fechaDesde = new Date();
        fechaDesde.setDate(fechaDesde.getDate() - this.sucursalSeleccionada.historico_dias);
        this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
        this.ubicaciones = [];
        //Buscar sensores
        this.nodoService.getNodosBySucursal(id)
            .subscribe((data) => {
                let i = 0;
                let ubicacionAnt = null;
                let nodo = null;
                this.nodos = data;
                var ubicacion = null;
                this.ubicaciones = [];
                while (i < this.nodos.length) {
                    nodo = this.nodos[i];
                    ubicacionAnt = nodo.ubicacion_id._id;
                    ubicacion = new Ubicacion();
                    ubicacion = nodo.ubicacion_id;
                    ubicacion.sensores = [];
                    while (i < this.nodos.length && ubicacionAnt == nodo.ubicacion_id._id) {
                        ubicacion.sensores = ubicacion.sensores.concat(nodo.sensores_id);
                        i++;
                        nodo = this.nodos[i];
                    }
                    this.ubicaciones.push(ubicacion);
                }
            });
        this.loadTable();
    }

    ocultarBarraSelectora() {
        if ($('#barraSelectora').css("display") == "block")
            $('#barraSelectora').css("display", "none");
        else
            $('#barraSelectora').css("display", "block");
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/regAlarma/regalarmas.component.ts